export default __webpack_public_path__ + "static/media/landing.8baf1a45.png";